// eslint-disable-next-line @typescript-eslint/no-empty-function
export const NOOP = () => { }

export const NOOP_ASYNC = () => Promise.resolve();
